import { Button } from "@shopify/polaris"
import classNames from "classnames"
import { observer } from "mobx-react"
import { ProPopoverWithItems } from "polaris-enhance"
import { useState } from "react"

import APIApp from "@/api/app"
import { langList, setLocal } from "@/locales/config"
import stores from "@/stores"
const OnboardingTopBar = observer(
  (props: { currentStep: number; isSaving: boolean; onSkip: () => void }) => {
    const { currentStep, isSaving, onSkip } = props
    const currentLanguage = stores.UserInfoStore.data.language_admin || "en"
    const [isLangOpen, setIsLangOpen] = useState(false)

    const handleChangeLanguage = async (value: string) => {
      setLocal(value)
      stores.UserInfoStore.data.language_admin = value
      await APIApp.updateAdminLanguage({ code: value })
    }

    const currentLanguageLabel = langList.find(
      (lang) => lang.value === (currentLanguage || "en"),
    )?.label

    if (currentStep === 4) return null

    return (
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {[1, 2, 3, 4].map((step) => {
            return (
              <div
                className={classNames(
                  "h-2 rounded-full transition-all",
                  step === currentStep
                    ? "w-5 bg-[#1274ff]"
                    : "w-[0.5rem] bg-[var(--p-color-bg-fill-tertiary,#d4d4d4)]",
                )}
                key={step}
              />
            )
          })}
        </div>
        <div className="flex items-center text-[13px] leading-5">
          <ProPopoverWithItems
            preferredAlignment="right"
            onShowChange={setIsLangOpen}
            activator={
              <Button
                variant="tertiary"
                disclosure={isLangOpen ? "up" : "down"}
              >
                {currentLanguageLabel}
              </Button>
            }
            items={langList.map((lang) => ({
              active: lang.value === currentLanguage,
              content: lang.label,
              onAction: () => handleChangeLanguage(lang.value),
            }))}
          />
          <Button variant="tertiary" onClick={onSkip}>
            {t("SkipSetup")}
          </Button>
        </div>
      </div>
    )
  },
)

export default OnboardingTopBar
